import React from 'react';
import { STAGES } from '../data/mockData';
import { LoanStage } from '../types';
interface StageFilterProps {
  activeStage: LoanStage | 'All';
  onStageChange: (stage: LoanStage | 'All') => void;
  stageCounts: Record<LoanStage | 'All', number>;
}
export const StageFilter: React.FC<StageFilterProps> = ({
  activeStage,
  onStageChange,
  stageCounts
}) => {
  return <div className="w-full overflow-x-auto pb-4 hide-scrollbar" data-id="element-144">
      <div className="flex space-x-2 min-w-max" data-id="element-145">
        <button onClick={() => onStageChange('All')} className={`flex items-center px-4 py-2 rounded-full text-sm font-medium transition-all ${activeStage === 'All' ? 'bg-gray-900 dark:bg-gray-100 text-white dark:text-gray-900 shadow-sm' : 'bg-white dark:bg-gray-800 text-gray-600 dark:text-gray-300 border border-gray-200 dark:border-gray-700 hover:border-gray-300 dark:hover:border-gray-600 hover:bg-gray-50 dark:hover:bg-gray-700'}`} data-id="element-146">
          All Loans
          <span className={`ml-2 px-2 py-0.5 rounded-full text-xs font-semibold flex items-center justify-center ${activeStage === 'All' ? 'bg-gray-700 dark:bg-gray-300 text-gray-100 dark:text-gray-800' : 'bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-300'}`} data-id="element-147">
            {stageCounts['All']}
          </span>
        </button>

        {STAGES.map(stage => <button key={stage} onClick={() => onStageChange(stage)} className={`flex items-center px-4 py-2 rounded-full text-sm font-medium transition-all ${activeStage === stage ? 'bg-gray-900 dark:bg-gray-100 text-white dark:text-gray-900 shadow-sm' : 'bg-white dark:bg-gray-800 text-gray-600 dark:text-gray-300 border border-gray-200 dark:border-gray-700 hover:border-gray-300 dark:hover:border-gray-600 hover:bg-gray-50 dark:hover:bg-gray-700'}`} data-id="element-148">
            {stage}
            <span className={`ml-2 px-2 py-0.5 rounded-full text-xs font-semibold flex items-center justify-center ${activeStage === stage ? 'bg-gray-700 dark:bg-gray-300 text-gray-100 dark:text-gray-800' : 'bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-300'}`} data-id="element-149">
              {stageCounts[stage] || 0}
            </span>
          </button>)}
      </div>
    </div>;
};